const chatBody = document.getElementById("chatBody");
const input = document.getElementById("userInput");
const sendBtn = document.getElementById("sendBtn");

async function sendMessage() {
  const text = input.value.trim();
  if (!text) return;

  addMessage(text, "user");
  input.value = "";

  const reply = await window.getBotReply(text);
  addMessage(reply, "bot");
}

/* ==============================
   EVENT BINDINGS
============================== */
sendBtn.addEventListener("click", sendMessage);

input.addEventListener("keydown", function (event) {
  if (event.key === "Enter") {
    sendMessage();
  }
});


/* ==============================
   TIME FORMATTER
============================== */
function getCurrentTime() {
  return new Date().toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit"
  });
}

/* ==============================
   ADD MESSAGE TO UI
============================== */
function addMessage(text, sender) {
  const message = document.createElement("div");
  message.className = "message " + sender;

  const time = document.createElement("div");
  time.className = "time";
  time.innerText = getCurrentTime();

  // Create text node (preserves line breaks)
  const textNode = document.createElement("div");
  textNode.className = "message-text";
  textNode.innerText = text;
  
  message.appendChild(textNode);
  message.appendChild(time);

  chatBody.appendChild(message);
  chatBody.scrollTop = chatBody.scrollHeight;
}

/* ==============================
   TYPING INDICATOR
============================== */
function showTyping() {
  const typing = document.createElement("div");
  typing.id = "typing";
  typing.className = "message bot";
  typing.innerText = "Typing...";
  chatBody.appendChild(typing);
  chatBody.scrollTop = chatBody.scrollHeight;
}

function removeTyping() {
  const typing = document.getElementById("typing");
  if (typing) {
    typing.remove();
  }
}

/* ==============================
   SEND MESSAGE FLOW
============================== */
function sendMessage() {
  const userText = input.value.trim();
  if (!userText) return;

  addMessage(userText, "user");
  input.value = "";

  showTyping();

  setTimeout(function () {
    removeTyping();
    
    // Get bot reply
    let reply = "Sorry, I'm having trouble connecting to the bot.";
    
    try {
      if (window.getBotReply) {
        reply = window.getBotReply(userText);
      } else {
        reply = "Bot function not loaded yet. Please wait...";
      }
    } catch (error) {
      console.error("Bot error:", error);
      reply = "I encountered an error. Please try again.";
    }
    
    addMessage(reply, "bot");
    
    // Debug info in console
    console.log("Question:", userText);
    console.log("Answer:", reply.substring(0, 50) + "...");
    
  }, 800); // Reduced from 1200ms for better UX
}

/* ==============================
   WELCOME MESSAGE
============================== */
setTimeout(function () {
  addMessage(
    "Namaste! Welcome to GulmoharTree Ayurveda. How can I assist you today?",
    "bot"
  );
}, 300);


/* ==============================
   INPUT AUTO-FOCUS
============================== */
setTimeout(function() {
  input.focus();
}, 1000);


// =========================
// TOGGLE CHAT WIDGET
// =========================
function toggleChat() {
  const chat = document.getElementById("chatWidget");
  if (!chat) return;
  chat.classList.toggle("open");
}
